import React, { memo } from 'react'
import { useHistory, useLocation } from 'react-router'
import { ReactComponent as BookedIllustration } from 'assets/illustrations/BookedIllustration.svg'
import { Box, Typography } from 'transfix-ui/core'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { ConfirmationModal } from 'transfix-ui'

export const TruckReminderModalDeprecated = memo(() => {
  const { trackEvent } = useFMSAnalytics()
  const history = useHistory()
  const { pathname = '' } = useLocation()
  const onCloseHandler = () => {
    history.push(pathname.replace(/(\/post-truck)/, ''))
  }
  const onSubmitHandler = () => {
    trackEvent('Truck Availability', 'CLICKED_POST_TRUCK_IN_POST_RATE_CON_MODAL')
    history.replace('/truck-availability?posting=true')
  }
  return (
    <ConfirmationModal
      onClose={onCloseHandler}
      size={6}
      open
      actions={[
        {
          label: 'Dismiss',
          type: 'dismiss',
        },
        {
          label: 'Post Truck Availability',
          type: 'confirm',
          action: onSubmitHandler,
        },
      ]}>
      <Box display='flex' flexDirection='column' alignItems='center'>
        <BookedIllustration className='external-load-illustration' />
        <Box textAlign='center'>
          <Box pt={2}>
            <Typography variant='h3'>
              Your load is booked! Have available trucks to post?
            </Typography>
          </Box>
          <Box pt={2} pb={2}>
            <Typography variant='body2'>
              If you have other trucks that you’d like to book loads for, post them to the truck
              availability planner to be notified as new loads come available for you to book.
            </Typography>
          </Box>
        </Box>
      </Box>
    </ConfirmationModal>
  )
})
